import React, { useEffect, useState } from 'react';
import { Pagination } from '../../Pagination';
import DeleteProductPopup from './DeleteProductPopup';
import CreateNewProductButton from './CreateNewProductButton';
import DownloadProductsCsvButton from './DownloadProductsCsvButton';
import SearchItemBlock from '../../../shared/SearchItemBlock';
import CreateNewProductPopup from './CreateNewProductPopup';
import { productsStorage } from '../../../services/productsStorage';
import ProductList from './ProductList';
import ProductTable from './ProductTable';
import { useTranslation } from 'react-i18next';
import useWindowDimensions from '../../../hooks/useWindowDimension';
import { productRestoreService } from '../../../services/productRestoreService';
import RestoreItemPopup from '../../../shared/RestoreItemPopup';
import { useListViewMode } from '../../../shared/listView/useListViewMode';
import ListViewSwitcher from '../../../shared/listView/ListViewSwitcher';

const ProductListTab = () => {
    const { i18n } = useTranslation();
    const { width } = useWindowDimensions();
    const { mode, setMode, isTableForcedOff } = useListViewMode('product');
    const [revision, setRevision] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    const notifyProductsList = () => {
        productsStorage.loadItems(() => setRevision((value) => value + 1), width);
    };

    useEffect(() => {
        const onChange = () => {
            setIsLoading(false);
            setRevision((value) => value + 1);
        };
        productsStorage.loadItems(onChange, width);
        productsStorage.registerFiltersChangingObserver(onChange);
        return () => {
            productsStorage.unRegisterFiltersChangingObserver(onChange);
            productsStorage.setPageNumber(1);
            productsStorage.cleanStorage();
        };
    }, []);

    const items = mode === 'table'
        ? productsStorage.getItems(true)
        : productsStorage.getItems();

    return (
        <>
            <SearchItemBlock
                itemsStorageService={productsStorage}
                placeholder={i18n.t('app.page.product.productSearch')}
                actions={
                    <>
                        <CreateNewProductButton />
                        <DownloadProductsCsvButton />
                        <ListViewSwitcher
                            mode={mode}
                            onChange={setMode}
                            disabled={isTableForcedOff}
                        />
                    </>
                }
            />
            {mode === 'table' ? (
                <ProductTable key={`table-${revision}`} items={items} isLoading={isLoading} />
            ) : (
                <ProductList key={`tile-${revision}`} items={items} />
            )}
            {mode === 'tile' ? <Pagination itemsStorageService={productsStorage} /> : null}
            <DeleteProductPopup notifyProductsList={notifyProductsList}/>
            <CreateNewProductPopup />
            <RestoreItemPopup itemRestoreService={productRestoreService} notifyItemsList={notifyProductsList}/>
        </>
    );
};

export default ProductListTab;
